import { createContext } from "react";

const MarkdownContext = createContext();

export default MarkdownContext;